import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import ServiceNotificationForm from './ServiceNotificationForm'
import {
  createNotificationTemplateAction,
  updateNotificationTemplateAction
} from '@/redux/order/serviceNotificationSlice'

class ServiceNotificationModal extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (formRef) => {
    const { baseProps } = this.props
    const { editingTemplate, onSuccess } = baseProps || {}

    try {
      // 获取表单值
      const values = await formRef.current.validateFields()

      // 格式化数据
      const formData = {
        templateName: values.templateName.trim(),
        templateType: values.templateType,
        title: values.title.trim(),
        content: values.content.trim(),
        channel: values.channel,
        enabled: values.enabled !== undefined ? values.enabled : true
      }

      // 如果有描述，添加到数据中
      if (values.description) {
        formData.description = values.description.trim()
      }

      // 调用保存接口
      const dispatch = this.props.dispatch
      if (editingTemplate) {
        // 更新模板
        await dispatch(updateNotificationTemplateAction({
          templateId: editingTemplate.templateId,
          data: formData
        })).unwrap()
        message.success('更新成功')
      } else {
        // 创建模板
        await dispatch(createNotificationTemplateAction(formData)).unwrap()
        message.success('创建成功')
      }

      // 调用成功回调
      if (onSuccess) {
        onSuccess()
      }

      return true // 返回 true 关闭弹窗
    } catch (error) {
      console.error('保存消息模板失败:', error)
      if (error && typeof error === 'string') {
        message.error(error)
      } else if (error?.errorFields) {
        // 表单验证错误，不显示消息
      } else {
        message.error('操作失败')
      }
      return false // 返回 false 不关闭弹窗
    }
  }

  handleCancel = () => {
    const { baseProps } = this.props
    const { onCancel } = baseProps || {}
    if (onCancel) {
      onCancel()
    }
  }

  render() {
    const { children, baseProps, title } = this.props
    const { editingTemplate } = baseProps || {}
    const isEdit = !!editingTemplate

    const baseComponent = (
      <ServiceNotificationForm
        editingTemplate={editingTemplate}
        dispatch={this.props.dispatch}
        templateTypeOptions={(baseProps && baseProps.templateTypeOptions) || []}
        channelOptions={(baseProps && baseProps.channelOptions) || []}
      />
    )

    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || (isEdit ? '编辑消息模板' : '新建消息模板')}
        width={600}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        centerTitle
        className="center-title-modal"
      />
    )
  }
}

// 使用函数组件作为wrapper来使用React Redux Hooks
const ServiceNotificationModalWrapper = (props) => {
  const dispatch = useDispatch()

  const enhancedProps = {
    dispatch,
    baseProps: {
      ...props.baseProps
    },
    ...props
  }

  return <ServiceNotificationModal {...enhancedProps} />
}

export default ServiceNotificationModalWrapper

